import React from 'react'
import PropTypes from 'prop-types'

const RestaurantAddress = ({ address1, address2, city, state }) =>
  <React.Fragment>
    {address1}{address2 ? ` ${address2}` : ''}, {city}, {state}
  </React.Fragment>

RestaurantAddress.propTypes = {
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired
}

export default React.memo(RestaurantAddress)
